// ----------------------------
// Created by Bulletproof Games
//            2020
//  www.bulletproofgames.co.uk
// ----------------------------
//
// BP Colour Box
//
// Simple coloured quad that can be used as a button

class ColourBox extends PIXI.Container {
  constructor() {
    super();
    this.quad = null;
    this.pressable = false;
    this.identifier = undefined; // user defined identifier. Can be left undefined
  }

  setTouchCallback(callback) {
    this.quad.mouseup = callback;
    this.quad.touchend = callback;
  }

  enableInteraction(enable) {
    if (!this.pressable) {
      return;
    }
    this.quad.interactive = enable;
  }

  setIdentifier(identifier) {
    this.identifier = identifier;
  }

  getIdentifier() {
    return this.identifier;
  }

  getVisible() {
    return this.visible;
  }

  show(show) {
    this.visible = show;
  }
}

let colourBoxInstantiator = {};

colourBoxInstantiator.create = function (json) {
  let res = new ColourBox();
  res.quad = new PIXI.Graphics();
  res.quad.clear();
  res.addChild(res.quad);
  return res;
};

colourBoxInstantiator.initialise = function (json, colourBox) {
  let colour = typeof json.colour === "undefined" ? "0x000000" : json.colour;
  let alpha = typeof json.alpha === "undefined" ? 1 : json.alpha;
  colourBox.pressable =
    typeof json.pressable === "undefined" ? false : json.pressable;

  let width = json.width;
  if (typeof width === "undefined") {
    width = 0;
  }
  let height = json.height;
  if (typeof height === "undefined") {
    height = 0;
  }

  colourBox.quad.clear();
  colourBox.quad.beginFill(colour, alpha);
  colourBox.quad.drawRect(0, 0, width, height);
  colourBox.quad.endFill();

  if (colourBox.pressable) {
    colourBox.quad.interactive = true;
    colourBox.quad.buttonMode = true;
    colourBox.quad.hitArea = new PIXI.Rectangle(0, 0, width, height);
  } else {
    colourBox.quad.interactive = false;
    colourBox.quad.buttonMode = false;
  }
};

colourBoxInstantiator.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  "colourBox",
  colourBoxInstantiator.create,
  colourBoxInstantiator.initialise,
  colourBoxInstantiator.getFilesRequired
);
